import dayjs, { Dayjs } from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
export const getAge = (dob?: Dayjs | Date | string, format = 'DD/MM/YYYY') => {
  return dayjs(dob, format).toNow(true).match(/\d+/)?.[0] || '0'
}
